const PrivateRoutes = {
  path: '/',
  name: 'Home',
  component: () => import('@/layouts/DefaultLayout.vue'),
  meta: {
    requiresAuth: true
  },
  redirect: '/main',
  children: [
    {
      name: 'Dashboard',
      path: '/',
      component: () => import('@/pages/base/DashboardPage/DashboardPage.vue')
    },
    {
      name: 'Profile',
      path: '/profile',
      component: () => import('@/pages/base/ProfilePage/ProfilePage.vue')
    },
    {
      name: 'Suppliers',
      path: '/suppliers',
      component: () => import('@/pages/base/SuppliersPage/SuppliersPage.vue')
    },
    {
      name: 'Requests',
      path: '/requests',
      component: () => import('@/pages/base/RequestsPage/RequestsPage.vue')
    },
    {
      name: 'New Request',
      path: '/requests/new-request/:id',
      component: () => import('@/pages/base/NewRequestPage/NewRequestPage.vue')
    },
    {
      name: 'View Request',
      path: '/requests/view-request/:id',
      component: () => import('@/pages/base/ViewRequestPage/ViewRequestPage.vue')
    },
    {
      name: 'View Invite Response',
      path: '/requests/view-request/:id/:inviteId',
      component: () => import('@/pages/base/InviteResponsePage/InviteResponsePage.vue')
    }
  ]
};

export default PrivateRoutes;
